import { ConfigService } from "../../services/config.service";
import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { TokenService } from "./token.service";
import { HttpClient } from "@angular/common/http";
import { AuthRoute } from "./auth.route";
import { IAuthUser } from "./interfaces";
import { HttpBaseService } from "../../services/http-base.service";
import { MessageService } from "primeng/api";
import { ClaimTypes } from "../../helpers/claimtype";

@Injectable({
  providedIn: "root"
})
export class AuthService<T extends IAuthUser> extends HttpBaseService {
  private _authRoute: AuthRoute;

  loading = false;
  model: T = <any>{};

  constructor(
    http: HttpClient,
    configService: ConfigService,
    router: Router,
    tokenService: TokenService,
    toastr: MessageService
  ) {
    super(configService, tokenService, router, http, toastr);
    this._authRoute = this.configService.getAuthRoute();
  }

  login(callback: Function, callbackError?: Function) {
    this.postMethod(
      this._authRoute.LoginSegment,
      this.model,
      callback,
      callbackError
    );
  }

  register(callback: Function, callbackError?: Function) {
    this.postMethod(
      this._authRoute.RegisterSegment,
      this.model,
      callback,
      callbackError
    );
  }

  logout() {
    this.getMethod(
      this._authRoute.LogOutSegment,
      () => {
        this.tokenService.removeToken();
        this.router.navigate([this._authRoute.LoginUrl]);
      },
      () => {
        this.tokenService.removeToken();
        this.router.navigate([this._authRoute.LoginUrl]);
      }
    );
  }

  refreshToken(callback: Function, callbackError?: Function) {
    this.getMethod(this._authRoute.RefreshSegment, callback, callbackError);
  }

  getModelFromToken() {
    return JSON.parse(this.tokenService.getValueFromClaim(ClaimTypes.UserData));
  }

  changePassword(callback: Function, callbackError?: Function) {
    this.postMethod(
      this._authRoute.ChangePasswordSegment,
      this.model,
      callback,
      callbackError
    );
  }

  resetPassword(callback: Function, callbackError?: Function) {
    this.postMethod(
      this._authRoute.ResetPasswordSegment,
      this.model,
      callback,
      callbackError
    );
  }

  toogleDisabled(callback: Function, callbackError?: Function) {
    this.postMethod(
      this._authRoute.ToogleDisabledSegment,
      this.model,
      callback,
      callbackError
    );
  }
}
